import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { upsertFinancialData } from '../../../../store/slices/editFinanceSlice';
import { fetchTaxes } from '../../../../store/slices/taxSlice';

const ProjectFinancialL2 = ({finalLead}) => {

    const columns = [
        { label: "Project Name", width: "w-[10%]" },
        { label: "Quoted Value", width: "w-[10%]" },
        { label: "Product Cost", width: "w-[10%]" },
        {
          label: "Gross Revenue",
          width: "w-[15%]",
          hasSubCols: true,
        },
        {
          label: "G & A cost",
          width: "w-[15%]",
          hasSubCols: true,
        },
        {
          label: "Income Before Tax",
          width: "w-[15%]",
          hasSubCols: true,
        },
        {
          label: "Tax Data",
          width: "w-[15%]",
          hasSubCols: true,
        },
        {
          label: "Net Revenue",
          width: "w-[15%]",
          hasSubCols: true,
        },
      ];

      const dispatch = useDispatch();


      const [finalLeadL2, setFinalLead] = useState([])
      const [reduxTaxData, setReduxTaxData ] = useState([])
      

        const { taxes } = useSelector((state) => state.taxes);
      
useEffect(()=>{
dispatch(fetchTaxes())
},[dispatch])

      useEffect(()=>{
          setFinalLead(finalLead);
          setReduxTaxData(taxes)
      },[finalLead,taxes])



        const [gaCost, setGaCost] = useState(); // for G & A %
        const [tax, setTax] = useState();
        const [productCost] = useState(111);
     
      
      
      useEffect(() => {
        if (Array.isArray(reduxTaxData)) {
          const gaCostData = reduxTaxData.find((item) => item.taxName.trim() === "G  and A Cost"
          );
          const taxData = reduxTaxData.find((item) => item.taxName.trim() === "Tax"
          );
      
          if (gaCostData) {
            setGaCost(gaCostData.taxPercentage);
          }
          if (taxData) {
            setTax(taxData.taxPercentage);
          }
        }
      }, [reduxTaxData]);

      const [calculatedLead, setCalculatedLead] = useState([])
      
        const prevValues = useRef({
          tax: null,
          gaCost: null,
          productCost: null,
          leadOverrides: null,
        });
      
        const [leadOverrides, setLeadOverrides] = useState({});
        useEffect(() => {
            setLeadOverrides({}); // clears overrides when lead changes
          }, [finalLeadL2]);
      
        useEffect(() => {
            if (!Array.isArray(finalLeadL2) || finalLeadL2.length === 0) return;
          // const cost = productCost;
          const newData = finalLeadL2.map((lead) => {
            const id =  lead.id; // 👈 normalize here
            const override = leadOverrides[id] || {};
      
            const cost = override.productCost ?? productCost;
            const ga = override.gaCost ?? gaCost;
            const t = override.tax ?? tax;
      
            const quotedValue = lead.QuotedValue;
            const grossRevenueDollar = quotedValue - cost;
            const grossRevenuePercentage =
              quotedValue > 0 ? (grossRevenueDollar / quotedValue) * 100 : 0;
      
            const generalAdminCostDollar = grossRevenueDollar * ga;
            const incomeBeforeTaxDollar = grossRevenueDollar - generalAdminCostDollar;
            const incomeBeforeTaxPercentage =
              quotedValue > 0 ? (incomeBeforeTaxDollar / quotedValue) * 100 : 0;
      
            const taxInDollar = incomeBeforeTaxDollar * t;
            const netProfitInDollar = incomeBeforeTaxDollar - taxInDollar;
            const netProfitInPercentage =
              quotedValue > 0 ? (netProfitInDollar / quotedValue) * 100 : 0;
      
            return {
              ...lead,
              productCost: cost,
              grossRevenueDollar: isNaN(grossRevenueDollar)
                ? 0
                : parseFloat(grossRevenueDollar.toFixed(2)),
              grossRevenuePercentage: isNaN(grossRevenuePercentage)
                ? 0
                : parseFloat(grossRevenuePercentage.toFixed(2)),
              generalAdminCostDollar: isNaN(generalAdminCostDollar)
                ? 0
                : parseFloat(generalAdminCostDollar.toFixed(2)),
              generalAdminCostPercentage: isNaN(ga) ? 0 : parseFloat(ga),
              incomeBeforeTaxDollar: isNaN(incomeBeforeTaxDollar)
                ? 0
                : parseFloat(incomeBeforeTaxDollar.toFixed(2)),
              incomeBeforeTaxPercentage: isNaN(incomeBeforeTaxPercentage)
                ? 0
                : parseFloat(incomeBeforeTaxPercentage.toFixed(2)),
              taxInDollar: isNaN(taxInDollar)
                ? 0
                : parseFloat(taxInDollar.toFixed(2)),
              taxInPercentage: isNaN(t) ? 0 : parseFloat(t),
              netProfitInDollar: isNaN(netProfitInDollar)
                ? 0
                : Math.round(netProfitInDollar),
              netProfitInPercentage: isNaN(netProfitInPercentage)
                ? 0
                : parseFloat(netProfitInPercentage.toFixed(2)),
            };
          });
          const cleanData = newData.map((lead) => ({
            leadID: lead.id,
            AssignedGroup: lead.AssignedGroup,
            ClientName: lead.ClientName,
            ProjectName: lead.ProjectName,
            QuotedValue: lead.QuotedValue,
            productCost: Number(lead.productCost),
            grossRevenue: lead.grossRevenueDollar,
            grossRevenuePercentage: lead.grossRevenuePercentage,
            generalAdminCostDollar: lead.generalAdminCostDollar,
            generalCost2: lead.generalAdminCostPercentage,
            incomeBeforeTaxDollar: lead.incomeBeforeTaxDollar,
            incomeBeforeTaxPercentage: lead.incomeBeforeTaxPercentage,
            taxInDollar: lead.taxInDollar,
            tax2: lead.taxInPercentage,
            netProfitInDollar: lead.netProfitInDollar,
            netProfitInPercentage: lead.netProfitInPercentage,
            leadDate: lead.LeadDate,
          }));
          setCalculatedLead(cleanData)
          // Only dispatch if the values really changed
          const {
            tax: prevTax,
            gaCost: prevGa,
            productCost: prevCost,
            leadOverrides: prevOverrides,
          } = prevValues.current;
      
          const currentOverridesStr = JSON.stringify(leadOverrides);
          const prevOverridesStr = JSON.stringify(prevOverrides);
      
          if (
            tax !== prevTax ||
            gaCost !== prevGa ||
            productCost !== prevCost ||
            currentOverridesStr !== prevOverridesStr
          ) {
            dispatch(upsertFinancialData(cleanData[0]));
            prevValues.current = {
              tax,
              gaCost,
              productCost,
              leadOverrides: leadOverrides,
            };
          }
        }, [finalLeadL2, tax, gaCost, productCost, dispatch, leadOverrides]);

  return (
    <div>
         <div className='ml-[18%] p-4 relative  scroll-visible justify-center'>
    
            <div className="flex bg-black text-white text-xs font-medium capitalize tracking-wider border-b">
              {columns.map((col, idx) =>
                col.hasSubCols ? (
                  <div
                    key={idx}
                    className={`text-center border flex flex-col ${col.width}`}
                  >
                    <div className="px-4 py-1 border-b">{col.label}</div>
                    <div className="flex text-xs">
                      <div className="w-1/2 border-r px-1 py-1">$</div>
                      <div className="w-1/2 px-1 py-1">%</div>
                    </div>
                  </div>
                ) : (
                  <div
                    key={idx}
                    className={`px-3 py-3 text-center border ${col.width}`}
                  >
                    {col.label}
                  </div>
                )
              )}
            </div> 

            {/* {(matchedLead.length > 0 ? matchedLead : finalLead).map( */}
         {(finalLeadL2?.length ? finalLeadL2 : calculatedLead ?? []).map(
  (item, index) => (
                <div key={index} className="flex border-b text-xs">
                  {/* Project Name */}
                  <div className="text-center border w-[10%] px-3 py-3 overflow-hidden whitespace-nowrap truncate">
                    {item.ProjectName}
                  </div>

                  {/* Quoted Value */}
                  <div className="text-center border w-[10%] px-4 py-2 overflow-hidden whitespace-nowrap truncate">
                    {item.QuotedValue}
                  </div>

                  {/* Product Cost */}
                  <div className="text-center border w-[10%] px-4 py-2 overflow-hidden whitespace-nowrap truncate">
                    <input
                      className="text-center w-full"
                      type="number"
                      value={
                        leadOverrides[item.id]?.productCost ??
                        item.productCost ?? 100
                        // leadOverrides[item.id]?.productCost ??
                        // item.productCost ??
                        // productCost
                      }
                      onChange={(e) =>
                        setLeadOverrides((prev) => {
                          const current = prev[item.id] || {
                            gaCost: item.generalCost2 ?? gaCost,
                            tax: item.tax2 ?? tax,
                          };
                          return {
                            ...prev,
                            [item.id]: {
                              ...current,
                              productCost: parseFloat(e.target.value),
                            },
                          };
                        })
                      }
                    />
                  </div>

                  {/* Gross Revenue */}
                  <div className="text-center border w-[15%] flex">
                    <div className="w-1/2 border-r px-1 py-1 truncate">
                      {item.grossRevenue}
                    </div>
                    <div className="w-1/2 px-1 py-1 truncate">
                      {item.grossRevenuePercentage}
                    </div>
                  </div>

                  {/* G&A Cost */}
                  <div className="text-center border w-[15%] flex">
                    <div className="w-1/2 border-r px-1 py-1 truncate">
                      {item.generalAdminCostDollar}
                    </div>
                    <div className="w-1/2 px-1 py-1 truncate">
                      <input
                        className="text-center w-full"
                        type="number"
                        value={
                          leadOverrides[item.id]?.gaCost ??
                          item.generalCost2 ??
                          gaCost
                        }
                        onChange={(e) =>
                          setLeadOverrides((prev) => {
                            const current = prev[item.id] || {
                              productCost: item.productCost ?? productCost,
                              tax: item.tax2 ?? tax,
                            };
                            return {
                              ...prev,
                              [item.id]: {
                                ...current,
                                gaCost: parseFloat(e.target.value),
                              },
                            };
                          })
                        }
                      />
                    </div>
                  </div>

                  {/* Income Before Tax */}
                  <div className="text-center border w-[15%] flex">
                    <div className="w-1/2 border-r px-1 py-1 truncate">
                      {item.incomeBeforeTaxDollar}
                    </div>
                    <div className="w-1/2 px-1 py-1 truncate">
                      {item.incomeBeforeTaxPercentage}
                    </div>
                  </div>

                  {/* Tax Data */}
                  <div className="text-center border w-[15%] flex">
                    <div className="w-1/2 border-r px-1 py-1 truncate">
                      {item.taxInDollar}
                    </div>
                    <div className="w-1/2 px-1 py-1 truncate">
                      <input
                        className="text-center w-full"
                        type="number"
                        value={leadOverrides[item.id]?.tax ?? item.tax2 ?? tax}
                        onChange={(e) =>
                          setLeadOverrides((prev) => {
                            const current = prev[item.id] || {
                              productCost: item.productCost ?? productCost,
                              gaCost: item.generalCost2 ?? gaCost,
                            };
                            return {
                              ...prev,
                              [item.id]: {
                                ...current,
                                tax: parseFloat(e.target.value),
                              },
                            };
                          })
                        }
                      />
                    </div>
                  </div>

                  {/* Net Revenue */}
                  <div className="text-center border w-[15%] flex">
                    <div className="w-1/2 border-r px-1 py-1 truncate">
                      {item.netProfitInDollar}
                    </div>
                    <div className="w-1/2 px-1 py-1 truncate">
                      {item.netProfitInPercentage}
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
    </div>
  )
}

export default ProjectFinancialL2